"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.steamEndpoints = void 0;
const saveSteamUserInfo_endpoint_1 = require("root/src/shared/steam/endpoints/saveSteamUserInfo.endpoint");
exports.steamEndpoints = Object.assign({}, saveSteamUserInfo_endpoint_1.saveSteamUserInfoEndpoint);
